export default "__VITE_ASSET__Dlx4dAhr__"